type EventListenerFn = (event: Event) => void;

// nodejs dont handle EventTarget with browser CustomEvent
class CustomEventEmitter {
  private _listeners: Map<string, EventListenerFn[]> = new Map();

  public addEventListener(type: string, listener: EventListenerFn): void {
    if (!this._listeners.has(type)) {
      this._listeners.set(type, []);
    }
    this._listeners.get(type)!.push(listener);
  }

  public removeEventListener(type: string, listener: EventListenerFn): void {
    if (this._listeners.has(type)) {
      this._listeners.set(
        type,
        this._listeners.get(type)!.filter((l: EventListenerFn) => l !== listener)
      );
    }
  }

  public dispatchEvent(event: Event): boolean {
    if (this._listeners.has(event.type)) {
      for (const listener of this._listeners.get(event.type)!) {
        listener(event);
      }
      return true; // Event was handled
    }
    return false; // No listeners
  }
}

export function globalThisEventTarget(): CustomEventEmitter {
  (globalThis as any).eventTarget ??= new CustomEventEmitter();
  return (globalThis as any).eventTarget;
}
